import S3FileUpload from './ReactS3Lib/ReactS3';
import { S3BucketConfig, PATHS } from '../common/constants';
import moment from 'moment';
import { toast } from 'react-toastify';

export const upload = async (file) => {
  let newFileName;
  if (file && file.path) {
    newFileName =
      file.path.split(/\.(?=[^\.]+$)/)[0] +
      moment().format('MMDDYYYYhmmss') +
      '.' +
      file.path.split(/\.(?=[^\.]+$)/)[1];
  }

  return await S3FileUpload.uploadFile(file, S3BucketConfig, newFileName)
    .then((data) => {
      return data.location;
    })
    .catch((err) => console.log(err));
};

export const clearStorageData = async () => {
  Promise.all([
    localStorage.removeItem('userId'),
    localStorage.setItem('isSignedOut', true),
    localStorage.setItem('sessionTimeOut', 'true'),
    localStorage.removeItem('auth'),
    localStorage.removeItem('user'),
    localStorage.removeItem('persist:root'),
  ]).then(() => {
    if (localStorage.getItem('isAnnotationImageUpload') === 'true') {
      localStorage.removeItem('isAnnotationImageUpload');
      toast.error('🚫 There was an issue logging out, try again later', {
        autoClose: 12000,
        position: 'top-center',
      });
    } else {
      window.location.href = window.location.origin + PATHS.AUTH_SIGN_IN;
    }
  });
};

export const logout = async () => {
  await clearStorageData();
};
